import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "mt-4 float-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workflow_navigation = _resolveComponent("workflow-navigation")!
  const _component_everything_you_want = _resolveComponent("everything-you-want")!
  const _component_decide_on_risk = _resolveComponent("decide-on-risk")!
  const _component_scenario = _resolveComponent("scenario")!
  const _component_income_and_pots = _resolveComponent("income-and-pots")!
  const _component_leave_pots_untouched = _resolveComponent("leave-pots-untouched")!
  const _component_page_nav = _resolveComponent("page-nav")!
  const _component_contact_us = _resolveComponent("contact-us")!
  const _component_solve_buttons = _resolveComponent("solve-buttons")!
  const _component_modal = _resolveComponent("modal")!
  const _component_shortfall_solver = _resolveComponent("shortfall-solver")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("header", _hoisted_1, [
        _createVNode(_component_workflow_navigation, { workflowStage: "Design" }),
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "skin-page-heading" }, "Your retirement", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "col-sm-8 mx-auto" }, " Answer the questions and see if your plan works, if not, you don't need to go back, just hit solve to fix. ", -1))
      ]),
      _createVNode(_component_everything_you_want),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_decide_on_risk, { ref: "decideOnRisk" }, null, 512),
          _createVNode(_component_scenario, {
            ref: "scenario",
            scenario: _ctx.ScenarioType.AccordingToPlan,
            solveEnabled: true,
            guaranteedIncomeEnabled: true,
            finishEncouragementEnabled: true,
            onSolveTakeLess: _ctx.onSolveTakeLess,
            onSolvePayMore: _ctx.onSolvePayMore,
            onSolveEquityRelease: _ctx.onSolveEquityRelease
          }, null, 8, ["scenario", "onSolveTakeLess", "onSolvePayMore", "onSolveEquityRelease"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_income_and_pots),
          _createVNode(_component_leave_pots_untouched, { ref: "leavePotsUntouched" }, null, 512)
        ])
      ]),
      _createVNode(_component_page_nav, {
        backLink: "income",
        onNextClicked: _ctx.onNextClicked,
        "parent-will-handle-next": true,
        "next-link": _ctx.nextLink
      }, null, 8, ["onNextClicked", "next-link"]),
      _createVNode(_component_contact_us, { class: "mt-5" })
    ]),
    _createVNode(_component_modal, {
      ref: "lastChanceSolveModal",
      title: "Shortfall",
      idKey: "lastChanceSolveModal",
      key: "lastChanceSolveModal",
      "close-button-aria-label": "Your plan has shortfalls and would be expected to run out of money if everything goes to plan. Do you want to try and solve these before leaving?"
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("p", null, " Your plan has shortfalls and would be expected to run out of money if everything goes to plan. ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "Do you want to try and solve these before leaving?", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_solve_buttons, {
            onSolveTakeLess: _ctx.onLastChanceSolveTakeLess,
            onSolvePayMore: _ctx.onLastChanceSolvePayMore,
            onSolveEquityRelease: _ctx.onLastChanceSolveEquityRelease,
            scenario: _ctx.ScenarioType.AccordingToPlan
          }, null, 8, ["onSolveTakeLess", "onSolvePayMore", "onSolveEquityRelease", "scenario"]),
          _createElementVNode("button", {
            class: "btn btn-secondary mx-3 px-4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onProceedWithShortfallClick && _ctx.onProceedWithShortfallClick(...args)))
          }, " No ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_shortfall_solver, {
      ref: "shortfallSolver",
      onClosing: _ctx.onShortfallSolverClosing
    }, null, 8, ["onClosing"])
  ], 64))
}